import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiHoutenEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Houten"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={87.50}
      distance="70 km"
      duration="55-60 minuten"
    />
  );
}
